import { useEffect, useState } from 'react';

const navLinks = [
  { label: '首页', href: '#top' },
  { label: '全彩漫画', href: '#featured' },
  { label: '热门榜单', href: '#ranking' },
  { label: '分类速览', href: '#categories' },
  { label: '追更动态', href: '#latest' },
  { label: '常见问题', href: '#faq' },
  { label: '关于我们', href: '#about' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-background-100/90 backdrop-blur-md border-b border-background-300/60' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5" aria-label="韩漫映画 首页">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-950">
            <i className="ri-play-circle-fill text-xl" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-xl md:text-2xl text-foreground-50">韩漫映画</span>
            <span className="text-[10px] md:text-[11px] tracking-[0.2em] text-secondary-500">HANMOTION</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm whitespace-nowrap text-foreground-200 transition-colors hover:text-primary-400"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="#search"
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300/70 text-foreground-300 transition-colors hover:border-primary-400 hover:text-primary-400"
            aria-label="搜索"
          >
            <i className="ri-search-line text-lg" aria-hidden="true"></i>
          </a>
          <a
            href="#featured"
            className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-950 transition-colors hover:bg-primary-400"
          >
            开始追更
          </a>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300/70 text-foreground-100 lg:hidden"
          aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
          aria-expanded={menuOpen}
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`} aria-hidden="true"></i>
        </button>
      </div>

      {menuOpen && (
        <nav className="lg:hidden border-t border-background-300/50 bg-background-100/95 backdrop-blur-md px-4 py-4" aria-label="移动端导航">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-200 transition-colors hover:bg-background-300/50 hover:text-primary-400"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#featured"
              onClick={() => setMenuOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-center text-sm font-medium text-background-950 transition-colors hover:bg-primary-400"
            >
              开始追更
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}